// eslint-disable-next-line camelcase
export { UNSTABLE_ReactComponentTracker } from './reactComponentTracker';
//# sourceMappingURL=index.js.map